<div *ngIf="showModal" class="modal-content">
  <ng-content></ng-content>
</div>
